import ReactDOM from "react-dom";
import React, { useEffect, useState } from "react";
import { useHistory, withRouter } from "react-router-dom";
import "./HeaderNavBar.css";
import { AiFillCaretDown } from "react-icons/ai";
import { handleException } from "../../app/util/util";
import { NavDropdownMenu } from "react-bootstrap-submenu";
import * as CommonConstant from "../../app/constants/CommonConstant";
function SearchMenu(props) {
  const [openResultIndex, setOpenResultIndex] = useState(null);
  const history = useHistory();
  const userVO = JSON.parse(localStorage.getItem("userVO"));
  const { chapterId, bookId, bookISBN, lastReadPageNum } = props.bookVO;
  const keepMeLogIn = localStorage.getItem("keepLoggedIn") ? "true" : "false";
  const [state, setState] = useState({
    recentSearch: null,
    autoSuggestions: null,
    serviceCompetion: false,
    pageResultVOList: undefined,
    chapterResultVOList: undefined,
  });
  const getSessionVO = () => {
    return {
      appType: "web",
      deviceMacId: "",
      keepMeLoggedInFlag: keepMeLogIn,
      deviceOS: localStorage.getItem("deviceOS"),
      deviceType: localStorage.getItem("deviceType"),
      browserName: localStorage.getItem("browserName"),
      sessionAuthenticationToken: userVO.sessionAuthenticationToken,
    };
  };
  useEffect(() => {
    var searchHistory = JSON.parse(localStorage.getItem("searchHistory"));
    if (Array.isArray(searchHistory)) {
      searchHistory.slice(0, CommonConstant.RECENT_SEARCH_LIMIT);
      setState({ ...state, recentSearch: searchHistory });
    }
  }, []);
  const updatePageNumber = (pageNum) => {
    document.getElementById("pageNumTxt").value = pageNum;
    localStorage.setItem("lastPageReadNum", pageNum);
    navigateToPage(pageNum);
  };
  const navigateToPage = async (pageNumber) => {
    let reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          lastReadSectionId: "",
          lastReadBookId: bookId,
          lastViewedOutlineId: "",
          pageNavigatingTo: "EReader",
          lastReadChapterId: chapterId,
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          lastReadParagraphId: "para01",
          lastReadPageNum: lastReadPageNum,
          lastReadSubSectionId: "subsec01",
        },
        sessionVO: getSessionVO(),
      },
      bookVO: { bookId: bookId, pageNumber: pageNumber },
    };
    const requestOptions1 = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    try {
      const data = await (
        await fetch(
          `${localStorage.getItem("ENV")}/bookContentRetrievalService/getChapterIdByPageNumb`,
          requestOptions1,
        )
      ).json();
      if (data.status === "true" && data.bookVO) {
        let pageHtmlLocation = data.bookVO.pageHtmlLocation;
        if (data.bookVO.pageHtmlLocation) {
          let location = pageHtmlLocation.substr(pageHtmlLocation.indexOf("#"));
          let chapterId = pageHtmlLocation.substr(
            0,
            pageHtmlLocation.indexOf("."),
          );
          if (location && chapterId)
            history.push(
              `/read/users/${userVO.userId}/books/${bookISBN}/${chapterId}${location}`,
            );
        }
      } else if (data.wkErrorCode) {
        handleException(data);
      }
    } catch (error) {
      console.error(
        "There has been a problem with your fetch operation:",
        error,
      );
    }
  };
  const searchByPage = async () => {
    let reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          lastReadBookId: "",
          lastReadPageNum: "",
          lastReadChapterId: "",
          lastReadSectionId: "",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "Bookshelf",
        },
        sessionVO: getSessionVO(),
      },
      contentSearchVO: {
        bookId: bookId,
        searchKeyWord: document.getElementById("searchField-fromControl").value,
      },
    };
    const requestOptions1 = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    try {
      const data = await (
        await fetch(
          `${localStorage.getItem("ENV")}/manageSearchService/searchTextInBook`,
          requestOptions1,
        )
      ).json();
      if (data && data.status === "true") {
        let pageResultVOList = data.contentSearchResultVOList;
        if (pageResultVOList) {
          pageResultVOList = Array.isArray(pageResultVOList)
            ? pageResultVOList
            : [pageResultVOList];
        }
        setState({
          ...state,
          pageResultVOList: pageResultVOList ? pageResultVOList : null,
          chapterResultVOList: undefined,
          serviceCompetion: true,
        });
      } else if (data.wkErrorCode) {
        handleException(data);
      }
    } catch (error) {
      console.error(
        "There has been a problem with your fetch operation:",
        error,
      );
    }
  };
  const searchBookContent = async () => {
    let searchKeyword = document.getElementById(
      "searchField-fromControl",
    ).value;
    if (searchKeyword !== null && searchKeyword.length >= 3) {
      let reqData = {
        userVO: {
          userId: userVO.userId,
          userRole: userVO.userRole,
          userRoleId: userVO.userRoleId,
          userActivityVO: {
            lastReadBookId: "",
            lastReadPageNum: "",
            lastReadChapterId: "",
            lastReadSectionId: "",
            lastReadParagraphId: "",
            lastViewedOutlineId: "",
            lastReadSubSectionId: "",
            lastActivityCode: "BOOKSHELF",
            pageNavigatingFrom: "EReader",
            pageNavigatingTo: "Bookshelf",
          },
          sessionVO: getSessionVO(),
        },
        contentSearchVO: {
          bookId: bookId,
          searchKeyWord: searchKeyword,
          paginationResultsPerPage: 100,
        },
      };
      const requestOptions1 = {
        method: "POST",
        body: JSON.stringify(reqData),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };
      try {
        const data = await (
          await fetch(
            `${localStorage.getItem("ENV")}/manageSearchService/searchTextInBookGroupByChapterId`,
            requestOptions1,
          )
        ).json();
        if (data && data.status === "true") {
          var searchHistory = JSON.parse(localStorage.getItem("searchHistory"));
          if (searchHistory === null) {
            var searchKeyWord = [
              document.getElementById("searchField-fromControl").value.trim(),
            ];
            localStorage.setItem(
              "searchHistory",
              JSON.stringify(searchKeyWord),
            );
            setState({ ...state, recentSearch: searchKeyWord });
          } else {
            searchHistory = Array.isArray(searchHistory)
              ? searchHistory
              : [searchHistory];
            if (
              searchHistory.find(
                (x) =>
                  x ===
                  document
                    .getElementById("searchField-fromControl")
                    .value.trim(),
              ) === undefined
            ) {
              searchHistory.unshift(
                document.getElementById("searchField-fromControl").value,
              );
              localStorage.setItem(
                "searchHistory",
                JSON.stringify(searchHistory),
              );
              var recentList = searchHistory.slice(
                0,
                CommonConstant.RECENT_SEARCH_LIMIT,
              );
              setState({
                ...state,
                recentSearch: recentList,
                serviceCompetion: true,
              });
            }
          }
          let chapterVOList = data.contentSearchResultVOList;
          if (data.contentSearchResultVOList) {
            chapterVOList = Array.isArray(chapterVOList)
              ? chapterVOList
              : [chapterVOList];
          }
          setState({
            ...state,
            chapterResultVOList: chapterVOList ? chapterVOList : null,
            pageResultVOList: undefined,
            serviceCompetion: true,
          });
          let accToggleChilds = document.querySelectorAll(
            ".dropdown-menu.accordionToggleChild",
          );
          if (accToggleChilds && accToggleChilds.length > 0) {
            accToggleChilds.forEach((item) => {
              item.classList.remove("show");
            });
          }
        } else if (data.wkErrorCode) {
          handleException(data);
        }
      } catch (error) {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      }
    }
  };
  const handleSearchTxtOnChange = async (e) => {
    let searchKeyword = document.getElementById(
      "searchField-fromControl",
    ).value;
    if (searchKeyword.length >= 3) {
      let reqData = {
        userVO: {
          userId: userVO.userId,
          userRole: userVO.userRole,
          userRoleId: userVO.userRoleId,
          userActivityVO: {
            lastReadBookId: "",
            lastReadPageNum: "",
            lastReadChapterId: "",
            lastReadSectionId: "",
            lastViewedOutlineId: "",
            lastReadParagraphId: "",
            lastReadSubSectionId: "",
            lastActivityCode: "BOOKSHELF",
            pageNavigatingFrom: "EReader",
            pageNavigatingTo: "Bookshelf",
          },
          sessionVO: getSessionVO(),
        },
        contentSearchVO: {
          bookId: bookId,
          searchKeyWord: searchKeyword,
          paginationResultsPerPage: 100,
        },
      };
      const requestOptions1 = {
        method: "POST",
        body: JSON.stringify(reqData),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };
      try {
        const data = await (
          await fetch(
            `${localStorage.getItem("ENV")}/manageSearchService/autoSuggestTextInBook`,
            requestOptions1,
          )
        ).json();
        if (data && data.status === "true") {
          if (data.autoSuggestSearchResultVOList !== undefined) {
            var autoSuggestions =
              data.autoSuggestSearchResultVOList.listEntries;
            if (autoSuggestions) {
              if (
                !Array.isArray(autoSuggestions) &&
                autoSuggestions.trim() === ""
              )
                setState({ ...state, autoSuggestions: null });
              else {
                autoSuggestions = Array.isArray(autoSuggestions)
                  ? autoSuggestions
                  : [autoSuggestions];
                setState({ ...state, autoSuggestions: autoSuggestions });
              }
            } else setState({ ...state, autoSuggestions: null });
          } else setState({ ...state, autoSuggestions: null });
        } else if (data.wkErrorCode) {
          handleException(data);
        }
      } catch (error) {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      }
    }
  };
  const handleSearch = () => {
    let searchTypeVal = document.getElementById("searchTypeDropDown").value,
      searchKeyword = document.getElementById("searchField-fromControl").value;
    if (searchTypeVal === "pageNumber" && searchKeyword.length >= 3)
      searchByPage();
    else searchBookContent();
  };
  const handleSearchClick = (e) => {
    if (e.charCode == 13) {
      setState({ ...state, autoSuggestions: null });
      handleSearch();
    }
  };

  // Handle Search result click

  const handleSearchResultClick = async (e) => {
    e.stopPropagation();
    const resultIndex = e.currentTarget.getAttribute("resultindex");
    let parentDiv = document.querySelector("#searchDetails_" + resultIndex);
    if (parentDiv && parentDiv.classList.contains("show")) {
      parentDiv.classList.remove("show");
      setOpenResultIndex(null);
    } else {
      setOpenResultIndex(resultIndex);
      let searchElement = document.getElementById(
        "chapterSearchRslt_" + resultIndex,
      );
      if (searchElement !== null) {
        let reqData = {
          userVO: {
            userId: userVO.userId,
            userRole: userVO.userRole,
            userRoleId: userVO.userRoleId,
            userActivityVO: {
              lastReadBookId: "",
              lastReadPageNum: "",
              lastReadChapterId: "",
              lastReadSectionId: "",
              lastReadParagraphId: "",
              lastViewedOutlineId: "",
              lastReadSubSectionId: "",
              lastActivityCode: "BOOKSHELF",
              pageNavigatingFrom: "EReader",
              pageNavigatingTo: "Bookshelf",
            },
            sessionVO: getSessionVO(),
          },
          contentSearchVO: {
            bookId: bookId,
            chapterId: searchElement.getAttribute("chapterId"),
            searchKeyWord: document.getElementById("searchField-fromControl")
              .value,
          },
        };
        const requestOptions1 = {
          method: "POST",
          body: JSON.stringify(reqData),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        };
        try {
          const data = await (
            await fetch(
              `${localStorage.getItem("ENV")}/manageSearchService/searchTextInBookForChapterId`,
              requestOptions1,
            )
          ).json();
          if (
            data &&
            data.status === "true" &&
            data.contentSearchResultVOList
          ) {
            let contentSearchResultVOList = data.contentSearchResultVOList;
            contentSearchResultVOList = Array.isArray(contentSearchResultVOList)
              ? contentSearchResultVOList
              : [contentSearchResultVOList];
            const rr1 = (
              <div
                className="dropdown-item accordionToggleChild"
                aria-labelledby="dropdownMenuLink"
              >
                {contentSearchResultVOList.map((rslt, i) => (
                  <a
                    data-testid={`sectionId_${i}`}
                    className="dropdown-item borderBottom"
                    href={`${process.env.PUBLIC_URL}/read/users/${userVO.userId}/books/${rslt.bookISBN}/${rslt.chapterId}#page-${rslt.pageNumber}`}
                    dangerouslySetInnerHTML={{
                      __html:
                        rslt.selectedText !== undefined
                          ? rslt.selectedText.replaceAll("\\n", "").trim()
                          : "",
                    }}
                  />
                ))}
              </div>
            );
            const title = React.createElement("span", {}, rr1);
            let res = document.getElementById("searchDetails_" + resultIndex);
            if (res) {
              ReactDOM.render(rr1, res);
              parentDiv.classList.add("show");
            }
          } else if (data.wkErrorCode) {
            handleException(data);
          }
        } catch (error) {
          console.error(
            "There has been a problem with your fetch operation:",
            error,
          );
        }
      }
    }
  };

  const onChangeSearchType = (e) => {
    let searchKeyword = document.getElementById(
      "searchField-fromControl",
    ).value;
    if (e.target.value === "pageNumber" && searchKeyword.length >= 3)
      searchByPage();
    else searchBookContent();
  };
  const handleRecentSearch = (e) => {
    setState({ ...state, autoSuggestions: null });
    document.getElementById("searchField-fromControl").value =
      e.target.getAttribute("keyword");
    let searchTypeVal = document.getElementById("searchTypeDropDown");
    if (searchTypeVal.value === "pageNumber") searchByPage();
    else searchBookContent();
  };
  const resultCount = () => {
    if (state.chapterResultVOList && Array.isArray(state.chapterResultVOList)) {
      var count = 0;
      for (var i = 0; i < state.chapterResultVOList.length; i++) {
        if (!isNaN(state.chapterResultVOList[i].numFound))
          count += parseInt(state.chapterResultVOList[i].numFound);
      }
      return <div role="alert"> Search Results ({count}) </div>;
    }
  };
  const pgResultCount = () => {
    if (state.pageResultVOList && Array.isArray(state.pageResultVOList)) {
      return (
        <div role="alert">
          {" "}
          Search Results ({state.pageResultVOList.length}){" "}
        </div>
      );
    }
  };
  return (
    <NavDropdownMenu
      title="Search"
      aria-label="search"
      id="collasible-dropdown-search"
    >
      <div className="searchDropDownField navBarSc rollBlock">
        <div style={{ padding: "10px" }}>
          <input
            data-testid="searchInputField"
            autoFocus
            id="searchField-fromControl"
            aria-label="Enter search term"
            className="form-control"
            placeholder="Search"
            onChange={handleSearchTxtOnChange}
            onKeyPress={handleSearchClick}
          ></input>
        </div>
        <svg
          data-testid="search"
          stroke="currentColor"
          fill="currentColor"
          onClick={handleSearch}
          stroke-width="0"
          viewBox="0 0 24 24"
          className="biSearchIcon"
          aria-labelledby="searchicontitle"
          height="1em"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title id="searchicontitle">Search within a book</title>
          <path d="M10,18c1.846,0,3.543-0.635,4.897-1.688l4.396,4.396l1.414-1.414l-4.396-4.396C17.365,13.543,18,11.846,18,10 c0-4.411-3.589-8-8-8s-8,3.589-8,8S5.589,18,10,18z M10,4c3.309,0,6,2.691,6,6s-2.691,6-6,6s-6-2.691-6-6S6.691,4,10,4z"></path>
        </svg>
        {state.autoSuggestions ? (
          <div>
            <div id="autoSuggestionContainer" className="autoSuggestions">
              <div className="recentSearchBlock_rt" aria-label="Auto-Suggest">
                Auto-Suggest
              </div>
              <div id="autoSuggest">
                {state.autoSuggestions !== null
                  ? state.autoSuggestions.map((x) => (
                      <div keyword={x} onClick={handleRecentSearch}>
                        {" "}
                        {x}
                      </div>
                    ))
                  : null}
              </div>
            </div>
          </div>
        ) : null}
        {state.recentSearch !== null ? (
          <div id="recentSearchSection">
            <div className="recentSearchBlock_rt" aria-label="Recent Searches">
              Recent Searches
            </div>
            <div id="recentSearch" className="autoSuggest_rt">
              {state.recentSearch !== null
                ? state.recentSearch.map((x) => (
                    <div keyword={x} onClick={handleRecentSearch}>
                      {" "}
                      {x}
                    </div>
                  ))
                : null}
            </div>
          </div>
        ) : null}
        {state.serviceCompetion &&
        !state.chapterResultVOList &&
        !state.pageResultVOList ? (
          <div role="alert" className="searchResultBlockContainer">
            No Results Found
          </div>
        ) : null}
        <div
          className="searchResultBlockContainer"
          style={{
            display:
              state.chapterResultVOList || state.pageResultVOList ? "" : "none",
          }}
        >
          <div className="displayResultBlock">
            {state.chapterResultVOList ? resultCount() : null}
            {state.pageResultVOList ? pgResultCount() : null}
            <label>Display Results By:</label>
            <select
              data-testid="searchTypeDropDown"
              id="searchTypeDropDown"
              name="dispalyresult"
              className="form-control displayResultList display-inline-block"
              onChange={onChangeSearchType}
            >
              <option
                selected
                className="selectedChapterSec"
                value="ChapterSection"
                aria-label="Chapter/Section"
              >
                Chapter/Section
              </option>
              <option
                className="toSelectList"
                value="pageNumber"
                aria-label="Page Number"
              >
                Page Number
              </option>
            </select>
          </div>
          {state.chapterResultVOList ? (
            <div id="searchBlockAccordianContainer" style={{ marginTop: "5%" }}>
              {state.chapterResultVOList.map((chapter, index) => (
                <div id="searchBlockAccordian">
                  <div className="dropdown show">
                    <span
                      className="btn dropdown-toggle searchBlockAccordianBtn accordionToggleParent"
                      sectionId={chapter.sectionId}
                      chapterId={chapter.chapterId}
                      pageNumber={chapter.pageNumber}
                      bookISBN={chapter.bookISBN}
                      resultindex={index}
                      onClick={handleSearchResultClick}
                      role="button"
                      id={"chapterSearchRslt_" + index}
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <div
                        className=""
                        sectionId={chapter.sectionId}
                        chapterId={chapter.chapterId}
                        pageNumber={
                          chapter.pageNumber !== undefined
                            ? chapter.pageNumber
                            : "NA"
                        }
                        bookISBN={chapter.bookISBN}
                        resultindex={index}
                      >
                        {chapter.chapterNumber ? (
                          <span
                            chapterId={chapter.chapterId}
                            pageNumber={chapter.pageNumber}
                            bookISBN={chapter.bookISBN}
                            resultindex={index}
                          >
                            Chapter{" "}
                            {unescape(
                              chapter.chapterNumber.replaceAll("\n", ""),
                            )}
                            :{" "}
                            {unescape(
                              chapter.chapterTitleInherit.replaceAll("\\n", ""),
                            ).trim()}
                          </span>
                        ) : null}
                      </div>
                      <span
                        className="resultsCount_rt"
                        sectionId={chapter.sectionId}
                        chapterId={chapter.chapterId}
                        pageNumber={chapter.pageNumber}
                        bookISBN={chapter.bookISBN}
                        resultindex={index}
                      >
                        {chapter.numFound > 1
                          ? chapter.numFound + " Results"
                          : chapter.numFound + " Result"}{" "}
                      </span>
                      <AiFillCaretDown
                        aria-hidden="true"
                        focusable="false"
                        className={`pull-right AiFillCaretDown ${
                          openResultIndex === String(index) ? "rotateIcon" : ""
                        }`}
                      />
                    </span>
                    <div
                      id={"searchDetails_" + index}
                      className="dropdown-menu accordionToggleChild"
                      aria-labelledby="dropdownMenuLink"
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          ) : state.chapterResultVOList === null ? (
            <div role="alert" className="noResult_rs">
              No Results Found
            </div>
          ) : null}
          {state.pageResultVOList ? (
            <div id="pageNumberContainer" style={{ marginTop: "5%" }}>
              {state.pageResultVOList.map((rslt, i) =>
                rslt.chapterId ? (
                  <div
                    id="pageNumTxt"
                    onClick={() => updatePageNumber(rslt.pageNumber)}
                  >
                    <div className="card border-secondary mb-3 pageNumberBlock">
                      <div
                        data-testid={`pageNumber_${i}`}
                        className="card-header"
                      >
                        p. {rslt.pageNumber}
                      </div>
                      <div className="card-body text-secondary">
                        <div
                          data-testid={`pageNumberSubBodyContent_${i}`}
                          className="pageNumberSubBodyContent"
                          dangerouslySetInnerHTML={{
                            __html:
                              rslt.selectedText !== undefined
                                ? rslt.selectedText.replaceAll("\\n", "").trim()
                                : "",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                ) : null,
              )}
            </div>
          ) : state.pageResultVOList === null ? (
            <div role="alert" className="noResult_rs">
              No Results Found
            </div>
          ) : null}
        </div>
      </div>
    </NavDropdownMenu>
  );
}
export default withRouter(SearchMenu);
